import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';

export class WelfareDTO {
@ApiProperty()
@ApiPropertyOptional()
Id: number;
@ApiProperty()
@ApiPropertyOptional()
text:string;
@ApiProperty()
@IsNotEmpty()
welfaretypeId: number;
@ApiProperty()
@ApiPropertyOptional()
currentStatus:string;
@ApiProperty()
@MaxLength(10, { message: "Mobile number allows 10 characters only. " })
@Matches(new RegExp("^[0-9\\s]+$"),{ message:"Mobile no should be only numeric. " })
mobileNo:string;
@ApiProperty()
@MaxLength(45, { message: "FirstName allows maximum 45 characters" })
@IsNotEmpty({message:"FirstName should not be empty"})
firstName:string;
@ApiProperty()
@ApiPropertyOptional()
@MaxLength(45, { message: "LastName Name allows maximum 45 characters" })
lastName: string;
@ApiProperty()
@ApiPropertyOptional()
address: string;
@ApiProperty()
@ApiPropertyOptional()
villageId:number;
@ApiProperty()
amount:number;
@ApiProperty()
@ApiPropertyOptional()
email: string;
@ApiProperty()
userId:number;
@ApiProperty({ type: 'array', items: { type: 'string', format: 'binary' } })
@ApiPropertyOptional()
 attachments?:string;
@ApiProperty()
@ApiPropertyOptional()
status: boolean;
createdAt : Date;
@ApiProperty()
@ApiPropertyOptional()
@IsOptional()
createdUser : number;
updatedAt : Date;
@ApiProperty()
@ApiPropertyOptional()
@IsOptional()
updatedUser : number;
@ApiProperty()
@ApiPropertyOptional()
versionFlag : number;
}
 
export class WelfareDeleteDTO{
       @ApiProperty()
       @IsNotEmpty({message:"Id should not be empty"})
       @IsNumber()
       Id: number;
       @ApiProperty()
       userId: number;
       @ApiProperty()
       status: boolean;
       updatedAt : Date;
       @ApiProperty()
       @ApiPropertyOptional()
       @IsOptional()
       updatedUser : number;
}

export class WelfareStatusDto{
  @ApiProperty()
  @IsNotEmpty({message:"Id should not be empty"})
  @IsNumber()
  welfareId: number;
  @ApiProperty()
  userId: number;
  @ApiProperty()
  welfareStatus: string;
  updatedAt : Date;
  @ApiProperty()
  @ApiPropertyOptional()
  @IsOptional()
  updatedUser : number;
}


